import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { usePageTitle } from '../../hooks/usePageTitle';
import { MapPin, Phone, ArrowRight, Sparkles } from 'lucide-react';
export function OurGallery() {
  usePageTitle('Our Gallery | MidAtlantic Mailboxes');
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1485" data-mp="ysjhmnmey031">
      <TopBar data-id="element-1486" data-mp="yq6y4610bhnv" />
      <Header data-id="element-1487" data-mp="13qup4rp8jyi3" />
      <Navigation data-id="element-1488" data-mp="13qb6f8rrh630" />

      <main className="flex-grow" data-id="element-1489" data-mp="13ptcwjwhh5ys">
        {/* Hero */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1490" data-mp="1rgysqz2fby93">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1491" data-mp="1reucrir938sg">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1492" data-mp="1w8ymuavtbwxr">
              First Impressions Start at the Curb
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1493" data-mp="2860bt1l7lbuo">
              Our Gallery
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-1494" data-mp="23e8w5m3lcqjb">
              MidAtlantic Mailbox, Inc. is your one-stop-shop for residential &
              commercial mailboxes, outdoor home accessories, street signs, and
              more. Please enjoy our gallery of completed installations for
              reference and inspiration.
            </p>
            <div className="mt-8 flex items-center justify-center gap-6" data-id="element-1495" data-mp="2m6kyi8u8vrtg">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/woman%20owned%20badge.png" alt="Woman Owned Business" className="h-14 object-contain" data-id="element-1496" data-mp="ws69dnfbe2xf" />
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/family%20owned%20badge.png" alt="Family Owned Business" className="h-14 object-contain" data-id="element-1497" data-mp="2wt4ibj06vbsy" />
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/florence%20logo%20badge.png" alt="Florence Authorized Dealer" className="h-12 object-contain" data-id="element-1498" data-mp="35vdoxxsc6l12" />
            </div>
          </div>
        </section>

        {/* What We Do */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1499" data-mp="3pijw2gj8nisk">
          <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-1500" data-mp="3tjx14oeibhyf">
            <p className="text-brand-muted leading-relaxed text-lg" data-id="element-1501" data-mp="3thk91if1br7n">
              Offering services like commercial mail route mapping, mailbox
              installations, and model identification & diagnostic solutions,
              MidAtlantic Mailbox, Inc. is your mailbox expert. Our experienced
              staff will assist you with the development of distinctive yet
              affordable street themes or development route mapping. We stay
              informed of postal requirements along with emerging industry
              trends to bring you the most up-to-date products and services. If
              you have a mailbox question, we're your answer.
            </p>
            <div className="mt-8 inline-flex items-center gap-2 bg-white border border-brand-border rounded-full px-5 py-2.5 text-sm font-semibold text-brand-charcoal shadow-sm" data-id="element-1502" data-mp="21l2ksfhay9ju">
              <MapPin size={16} className="text-brand-maroon" data-id="element-1503" data-mp="1rtoe9nqxo9h7" />
              Installation in the DC Metropolitan Region & parts of PA, VA, WV,
              MD, and DE
            </div>
          </div>
        </section>

        {/* Premiere Combinations / Browse */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1504" data-mp="243w04xklf5xw">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1505" data-mp="292pe0r3skyyl">
            <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-1506" data-mp="293ia8y54k62h">
              <span className="inline-flex items-center gap-2 text-brand-maroon font-bold tracking-wider uppercase text-xs mb-3" data-id="element-1507" data-mp="1v3h8zhky6wmh">
                <Sparkles size={14} data-id="element-1508" data-mp="202tx05nk29qn" /> Exclusive to MidAtlantic Mailbox
              </span>
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1509" data-mp="2nsob0qjm24ch">
                Premiere Mailbox System Combinations
              </h2>
              <p className="text-brand-muted" data-id="element-1510" data-mp="2e1tnliumoypg">
                Browse our Premiere Mailbox System Combinations, only available
                at MidAtlantic Mailbox, Inc.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1511" data-mp="36qr1l9rt49ce">
              <a href="/6m8/commercial-mailboxes-lockers.html" className="group bg-brand-background rounded-2xl border border-brand-border overflow-hidden hover:border-brand-maroon transition-colors shadow-sm" data-id="element-1512" data-mp="36oec8bjpywpb">
                <div className="aspect-[4/3] bg-brand-goldWash flex items-center justify-center" data-id="element-1513" data-mp="3gtcxos5r44dp">
                  <span className="text-brand-charcoal/40 text-sm font-medium" data-id="element-1514" data-mp="3ukreqtg3lvi4">
                    Commercial Mailboxes
                  </span>
                </div>
                <div className="p-5" data-id="element-1515" data-mp="31wvj7s29m9mx">
                  <h3 className="font-bold text-brand-charcoal group-hover:text-brand-maroon transition-colors mb-1" data-id="element-1516" data-mp="31xwy67mejg9x">
                    Commercial Mailboxes & Lockers
                  </h3>
                  <p className="text-sm text-brand-muted flex items-center gap-1" data-id="element-1517" data-mp="3bwcrmh8wj1ml">
                    Explore the collection{' '}
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-1518" data-mp="36yb6lqrx0s8h" />
                  </p>
                </div>
              </a>

              <a href="/m8/4C16D-20-D--versatile-4c-depot-16h-20-door-package.html" className="group bg-brand-background rounded-2xl border border-brand-border overflow-hidden hover:border-brand-maroon transition-colors shadow-sm" data-id="element-1519" data-mp="u6p1nfx994pr">
                <div className="aspect-[4/3] bg-brand-goldWash flex items-center justify-center" data-id="element-1520" data-mp="135kakzrooswr">
                  <span className="text-brand-charcoal/40 text-sm font-medium" data-id="element-1521" data-mp="1843y34lxecr8">
                    4C Depot Package
                  </span>
                </div>
                <div className="p-5" data-id="element-1522" data-mp="fikkwhhrj39m">
                  <h3 className="font-bold text-brand-charcoal group-hover:text-brand-maroon transition-colors mb-1" data-id="element-1523" data-mp="ffg5sp2ren46">
                    Featured 4C Mailbox System
                  </h3>
                  <p className="text-sm text-brand-muted flex items-center gap-1" data-id="element-1524" data-mp="p9owr8c56808">
                    View product details{' '}
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-1525" data-mp="3swfk3g5lyc1m" />
                  </p>
                </div>
              </a>

              <a href="/" className="group bg-brand-background rounded-2xl border border-brand-border overflow-hidden hover:border-brand-maroon transition-colors shadow-sm" data-id="element-1526" data-mp="3gf4powg483yg">
                <div className="aspect-[4/3] bg-brand-goldWash flex items-center justify-center" data-id="element-1527" data-mp="36fdtmqbwpgw9">
                  <span className="text-brand-charcoal/40 text-sm font-medium" data-id="element-1528" data-mp="32fv8btg6b3sw">
                    Residential & Street Signs
                  </span>
                </div>
                <div className="p-5" data-id="element-1529" data-mp="2snph4lxqwqer">
                  <h3 className="font-bold text-brand-charcoal group-hover:text-brand-maroon transition-colors mb-1" data-id="element-1530" data-mp="2sosd389xdj1j">
                    Start Browsing
                  </h3>
                  <p className="text-sm text-brand-muted flex items-center gap-1" data-id="element-1531" data-mp="2ip1g8zxw6rya">
                    Back to homepage{' '}
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-1532" data-mp="2equ8uvpbj2zr" />
                  </p>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-12 bg-brand-charcoal text-center" data-id="element-1533" data-mp="3spc79u2qse9c">
          <div className="max-w-3xl mx-auto px-4" data-id="element-1534" data-mp="1fna37fnw0j0">
            <p className="text-brand-gold font-bold mb-2" data-id="element-1535" data-mp="3juxxu84w7xy5">
              MidAtlantic Mailbox, Inc.
            </p>
            <p className="flex items-center justify-center gap-2 text-gray-300 text-sm mb-4" data-id="element-1536" data-mp="3om65aymnx98o">
              <MapPin size={16} className="shrink-0" data-id="element-1537" data-mp="39x097jj4fz50" />
              4507 Metropolitan Court Ste. D, Frederick, MD 21704
            </p>
            <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-white text-sm" data-id="element-1538" data-mp="3ewmnlwaorlfe">
              <span className="flex items-center gap-1" data-id="element-1539" data-mp="30wlmcfqiebze">
                <Phone size={14} data-id="element-1540" data-mp="34y6tdkgd3w1o" /> Toll Free: 1-800-806-7997
              </span>
              <span className="hidden sm:inline text-gray-500" data-id="element-1541" data-mp="2m9d5ayaircfi">|</span>
              <span data-id="element-1542" data-mp="2m9mvalvkdjl7">301-620-7585</span>
              <span className="hidden sm:inline text-gray-500" data-id="element-1543" data-mp="2hajr13nerhea">|</span>
              <span data-id="element-1544" data-mp="2hcd16sx8cjr1">301-620-7867</span>
              <span className="hidden sm:inline text-gray-500" data-id="element-1545" data-mp="2vaksak7l4qua">|</span>
              <span data-id="element-1546" data-mp="2v7oviz7h487f">240-575-5852</span>
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-1547" data-mp="2qdb1b04js74c" />
      <MobileStickyBar data-id="element-1548" data-mp="357z7kghrv9l0" />
    </div>;
}